import React from 'react';
import { Clock3Icon, ShieldCheckIcon, StarIcon } from 'lucide-react';
import { Badge } from '../Badge';
import { CtaButton } from '../CtaButton';
import { Logo } from '../Logo';
import { IMAGES } from '../../lib/content';
const STATS = [{
  value: '4.9',
  label: 'Avg patient rating',
  star: true
}, {
  value: '250+',
  label: 'Smiles transformed',
  star: false
}, {
  value: '12 years',
  label: 'Straumann® provider',
  star: false
}];
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-white" data-id="element-58" data-mp="qvm84sg5f0cq">
      <div className="pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-59" data-mp="qtszx8pw082m">
        <div className="absolute -top-32 -right-24 h-96 w-96 rounded-full bg-[#A9DFE9]/40 blur-3xl" data-id="element-60" data-mp="vnne5wmq3uub" />
        <div className="absolute top-1/2 -left-32 h-80 w-80 rounded-full bg-[#26B3CA]/15 blur-3xl" data-id="element-61" data-mp="10k45t0t4src5" />
      </div>

      <div className="relative mx-auto flex max-w-6xl items-center justify-between px-6 py-6" data-id="element-62" data-mp="15mcz5y9x1ves">
        <Logo size="md" aria-label="Pler Smile home" data-id="element-63" data-mp="1ak4teyy19tm5" />
        <div className="hidden items-center gap-2 text-sm font-semibold text-[#1F6E7B] sm:flex" data-id="element-64" data-mp="9oc84mzmpti7">
          <ShieldCheckIcon size={16} data-id="element-65" data-mp="4o6nvrvov9a5" />
          Dadeland, Kendall, Miami
        </div>
      </div>

      <div className="relative mx-auto grid max-w-6xl grid-cols-1 items-center gap-12 px-6 pb-16 pt-6 lg:grid-cols-2 lg:pb-24 lg:pt-10" data-id="element-66" data-mp="3vuhfyyiq0zpc">
        <div className="flex flex-col" data-id="element-67" data-mp="3rv09q2vgzyj4">
          <div className="mb-6 flex flex-wrap gap-2" data-id="element-68" data-mp="seaodqdkyswx">
            <Badge variant="aqua" size="sm" className="landing-badge" data-id="element-69" data-mp="sdskq8ol9cez">All-on-X Dental Implants</Badge>
            <Badge variant="sky" size="sm" className="landing-badge" data-id="element-70" data-mp="nfr3ltaq3n65">Pler Smile Dadeland</Badge>
            <Badge variant="outline" size="sm" className="landing-badge" data-id="element-71" data-mp="imxxp23iq8sh">5-Day Smile Experience</Badge>
          </div>

          <div className="mb-5 inline-flex w-fit items-center gap-2 rounded-full bg-[#1A1A2E] px-4 py-2 text-sm font-semibold text-white" data-id="element-72" data-mp="ekt6ea0jlo90">
            <Clock3Icon size={16} className="text-[#A9DFE9]" data-id="element-73" data-mp="16dju1w45u4mn" />
            Only 3 clinical openings remain this month
          </div>

          <h1 className="text-4xl font-bold leading-[1.05] tracking-tight text-[#1A1A2E] md:text-5xl lg:text-6xl" data-id="element-74" data-mp="30n8he9sjxint">
            When did smiling become something you avoid?
            <span className="mt-2 block text-[#1F6E7B]" data-id="element-75" data-mp="2qww0crjy47mf">5 days in Miami. Your final zirconia smile is waiting.</span>
          </h1>

          <p className="mt-6 max-w-xl text-lg leading-relaxed text-[#1A1A2E]/80" data-id="element-76" data-mp="2vtme388a2r4o">
            Complete All-on-X surgery with 3D facial design, four hotel nights, and airport
            transportation included. Start with one arch from{' '}
            <span className="font-bold text-[#1A1A2E]" data-id="element-77" data-mp="27x9qe8usrbgi">$20,000</span>.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-78" data-mp="27zmfd5yz2m32">
            <CtaButton data-id="element-79" data-mp="2cwl6rgr94exk" />
          </div>

          <dl className="mt-8 grid grid-cols-3 rounded-2xl bg-[#A9DFE9]/20 px-2 py-5 text-center sm:px-4" data-id="element-80" data-mp="6650picfckyt">
            {STATS.map((stat, index) => <div key={stat.label} className={index > 0 ? 'border-l border-[#1A1A2E]/15 px-2 sm:px-4' : 'px-2 sm:px-4'} data-id="element-81" data-mp="b3op3b2u6e4h" data-mpi={index}>
                <dd className="flex items-center justify-center gap-1 text-2xl font-bold tracking-tight text-[#1A1A2E] sm:text-3xl" data-id="element-82" data-mp="1vna9avqe6xtl">
                  {stat.value}
                  {stat.star ? <StarIcon size={20} className="fill-[#26B3CA] text-[#26B3CA]" aria-hidden="true" data-id="element-83" data-mp="25dlpbgncoxgu" /> : null}
                </dd>
                <dt className="mt-1 text-[10px] font-semibold uppercase tracking-[0.12em] text-[#1A1A2E]/65 sm:text-xs" data-id="element-84" data-mp="20k0pdj275tf0">{stat.label}</dt>
              </div>)}
          </dl>
        </div>

        <div className="relative" data-id="element-85" data-mp="2abn800gv6urs">
          <div className="overflow-hidden rounded-[2rem] shadow-soft ring-1 ring-[#A9DFE9]/60" data-id="element-86" data-mp="2obobzosfeibh">
            {/* TODO-IMAGE: replace with real onsite photo; consent on file with admin team */}
            <img src={IMAGES.hero} alt="Patient smiling confidently after her All-on-X treatment at Pler Smile Dadeland" className="h-full w-full object-cover" loading="eager" data-id="element-87" data-mp="txnbz0l53p9t" />
          </div>
          <div className="absolute -bottom-5 -left-5 hidden rounded-2xl bg-white px-5 py-4 shadow-soft ring-1 ring-[#A9DFE9]/60 sm:block" data-id="element-88" data-mp="p0wx2gl2mzpz">
            <div className="text-2xl font-bold text-[#1F6E7B]" data-id="element-89" data-mp="ve13zt5d4wdt">5 days</div>
            <div className="text-xs font-medium uppercase tracking-wide text-[#1A1A2E]/70" data-id="element-90" data-mp="10e6ompd7time">to your final smile</div>
          </div>
        </div>
      </div>
    </section>;
}